import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-preview-circular',
  templateUrl: './preview-circular.component.html',
  styleUrls: ['./preview-circular.component.scss']
})
export class PreviewCircularComponent implements OnInit {

  @Input() page: string; // Page where component is  used
  @Input() circularPreviewData: any; // Circular data for preview

  constructor() { }

  ngOnInit(): void {
  }

}
